// @ts-strict-ignore
import React, { ReactNode, useEffect, useRef, useState } from 'react';
// @ts-expect-error ts-migrate(2305) FIXME: Module '"styled-system"' has no exported member 'P... Remove this comment to see the full error message
import { Props as StyleProps } from 'styled-system';

import { Box } from 'components/Box';

function FixedSpacerContainer({
  children,
  ...props
}: StyleProps & {
  children: ReactNode;
}) {
  const ref = useRef(null);
  const [height, setHeight] = useState('auto');
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line consistent-return
  useEffect(() => {
    const update = () => {
      if (ref && ref.current) {
        setHeight(ref.current.offsetHeight || 'auto');
      }
    };

    update();

    if (window) {
      window.addEventListener('resize', update);
      return window.addEventListener('resize', update);
    }
  }, [children]);
  return (
    <Box height={height}>
      {/* TODO: Fix this the next time the file is edited. */}
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <Box position="fixed" {...props}>
        <div ref={ref}>{children}</div>
      </Box>
    </Box>
  );
}

// eslint-disable-next-line import/no-default-export
export default FixedSpacerContainer;
